<template>
  <v-app style="background-color:white">

     <v-card class="form-container" flat style="margin-top:-10px" v-if="form.accept==false">
      <b-form-checkbox v-model="status" >
        I accept all the <a href="https://csquad.infosyst.in/api/TermConditions/001" target="_blank">Terms & Conditions</a>
      </b-form-checkbox>

      <div style="padding-top:15px;">
        <v-btn :disabled="status==false" depressed @click="continues(form)" color="primary" :loading="btnSave">Continue</v-btn>
      </div>
     </v-card>
    <v-card class="form-container" flat style="margin-top:-10px" v-if="form.accept==true">
      <v-tabs
      v-model="tab"
      background-color="transparent"
      color="basil"
      grow
    >
    <v-tab>
        My Profile
      </v-tab>
      <v-tab>
        My Documents
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 style="padding-bottom:10px">
            <v-switch v-model="edit" label="Want to edit ?" color="primary" hide-details></v-switch>
          </v-flex>
            <v-flex xs12 sm12 md6 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.vendorName" label="Vendor Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md6>
                <v-text-field :disabled="edit === false" v-model="form.contactName" label="Contact Person Name *" :rules="emptyRule" required></v-text-field>
            </v-flex>

            <v-flex xs12 sm12>
              <v-autocomplete
              :disabled="edit === false"
              v-model="selectedCategory"
              :items="categories"
              color="primary"
              label="Select Category *"
              item-text="categoryName"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            </v-flex>

            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.contactNumber" label="Contact Number *" :rules="[rules.mobileno]" required></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.email" label="Email *"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3 style="padding-right:5px">
                <v-text-field :disabled="edit === false" v-model="form.gstNumber" label="GST Number"></v-text-field>
            </v-flex>
            <v-flex xs12 sm12 md3>
                <v-text-field :disabled="edit === false" v-model="form.panNumber" label="Pan Number"></v-text-field>
            </v-flex>

            <!-- BILLING  -->
          <v-flex xs12 md6 sm6 style="padding-right: 5px">
            <v-text-field :disabled="edit === false" v-model="form.billingCity" label="Billing city"></v-text-field>
            <v-text-field
               :disabled="edit === false"
              v-model="form.billingCountry"
              label="Billing country"
            ></v-text-field>
            <v-text-field
             :disabled="edit === false"
              v-model="form.billingZipCode"
              label="Billing zip code"
            ></v-text-field>
            <v-text-field
              :disabled="edit === false"
              v-model="form.billingStreet"
              label="Billing street"
            ></v-text-field>
            <v-autocomplete
              :disabled="edit === false"
              v-model="selectedBillingState"
              :items="states"
              color="primary"
              label="Select billing state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              :disabled="edit === false"
              v-model="form.billingAddress"
              label="Billing address"
            ></v-textarea>
          </v-flex>

          <!-- SHIPPING -->
          <v-flex xs12 md6 sm6 style="padding-left: 5px">
            <v-text-field
              :disabled="edit === false"
              v-model="form.shippingCity"
              label="Shipping city"
            ></v-text-field>
            <v-text-field
              :disabled="edit === false"
              v-model="form.shippingCountry"
              label="Shipping country"
            ></v-text-field>
            <v-text-field
              :disabled="edit === false"
              v-model="form.shippingZipCode"
              label="Shipping zip code"
            ></v-text-field>
            <v-text-field
              :disabled="edit === false"
              v-model="form.shippingStreet"
              label="Shipping Street"
            ></v-text-field>
            <v-autocomplete
              :disabled="edit === false"
              v-model="selectedShippingState"
              :items="states"
              color="primary"
              label="Select shipping state *"
              item-text="name"
              item-value="id"
              :rules="emptyRule" 
              required
            ></v-autocomplete>
            <v-textarea
              :disabled="edit === false"
              v-model="form.shippingAddress"
              label="Shipping address"
            ></v-textarea>
          </v-flex>

          <v-flex xs12 sm12 md12 style="text-align:right">
            <v-btn depressed color="#e53935" dark @click="back()">Cancel</v-btn>
            <v-btn :disabled="edit === false" depressed :loading="btnSave" color="primary" dark @click="onSubmit()">Save </v-btn>
          </v-flex>
          
        </v-layout>
      </v-form>
      </v-tab-item>
      <v-tab-item>
          <v-card-title>
        <span class="title">
          <v-icon color="#212121" size="28">description</v-icon>&nbsp;My Documents
        </span>
        <!-- <v-divider v-if="users.length < 2" color="#64f5a9" vertical class="mr-3 ml-3"></v-divider> -->
        <v-btn color="#e53935" depressed to="/addDocument" dark small class="txt_dec">
          Add
        </v-btn>
        <v-spacer></v-spacer>
        <v-spacer></v-spacer>
      </v-card-title>
      <p v-if="form.reason!=null" style="color:red;padding-top:15px;text-align:right;">{{form.reason}}</p>
      <v-data-table hide-actions :headers="tableHeader" :items="list" :search="search">
        <template v-slot:items="props">
          <td class="text-xs-left">{{ props.index + 1 }}</td>
          <td class="text-xs-left">{{ props.item.name }}</td>
          <td class="text-xs-left">
            <a target="_blank" :href=props.item.src>
              <v-btn depressed color="success" class="txt_dec">Download</v-btn>
            </a>
          </td>
          <td class="text-xs-left">
            <v-btn depressed color="error" @click="onDelete(props.item)">Delete</v-btn>
          </td>
          
        </template>
        <v-alert
          v-slot:no-results
          :value="true"
          color="error"
          icon="warning"
        >Your search for "{{ search }}" found no results.</v-alert>
      </v-data-table>


      <div style="text-align:right" v-if="form.reason!=null">
        <v-btn large color="primary" @click="onSubmit1(form)">Submit Your Documents</v-btn>
      </div>
      </v-tab-item>
      
    </v-tabs-items>
    </v-card>
  </v-app>
</template>

<script>
import config from "../../config.json";
export default {
  data() {
    return {
      tab: null,
      status: false,
      tableHeader: [
        { text: "#",
        align: 'left',
          sortable: false, value: "index" },
        { text: "Document Type", value: "name" },
        { text: "Download", value: "download" },
        { text: "Delete", value: "delete" }
      ],
      edit: false,
      title: "Create Counselling",
      entries: [],
      isLoading: false,
      model: null,
      search: null,
      btnSave: false,
      list: [],

      emptyRule: [v => !!v || "Input is required"],
      rules: {
        required: value => !!value || "Required.",
        email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(value) || "Invalid e-mail.";
      },
      mobileno: value => {
          const pattern = /^[1-9]{1}[0-9]{9}$/;
          return pattern.test(value) || "Mobile number not valid!!";
        },
      },
      valid: true,
      roleType: sessionStorage.roles,
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/_"
        },
        {
          text: "Vendor",
          disabled: false,
          to: "/vendor"
        },
        {
          text: "Edit",
          disabled: true,
          to: "/createStudent"
        }
      ],
      form: {
          vendorName: null,
          gstNumber: null,
          panNumber: null,
          contactName: null,
          contactNumber: null,

          billingAddress: null,
          billingCity: null,
          billingCountry: null,
          billingStreet: null,
          billingZipCode: null,

          shippingAddress: null,
          shippingCity: null,
          shippingCountry: null,
          shippingStreet: null,
          shippingZipCode: null
      },

      states: null,
      selectedBillingState: 1,
      selectedShippingState: 1,

      categories: [],
      selectedCategory: null
    };
  },

  mounted() {
      this.axios
        .get(config.API + `States`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.states = res.data;
          this.$Progress.finish();
        });

        this.axios
        .get(config.API + `Categories`, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.categories = res.data;
          this.$Progress.finish();
        });
      this.getData();
    },

  methods: {
    back() {
      this.$router.go(-1);
    },

    onSubmit1(item) {
        this.axios
          .delete(config.API + `Vendors2/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully Updated");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      
    },

    getData() {
      this.axios
      .get(config.API + `VendorProfile`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.form = res.data;
        this.selectedBillingState = res.data.billingStateCode;
        this.selectedShippingState = res.data.shippingStateCode;
      });

      this.axios
      .get(config.API + `VendorDocuments`, {
        headers: { Authorization: "Bearer " + sessionStorage.token }
      })
      .then(res => {
        this.list = res.data;
      });
    },

    onSubmit() {
      if (this.$refs.form.validate()) {
        this.btnSave = true;
        this.axios
          .put(
            config.API + `Vendors/${this.form.id}`,
            {
              id: JSON.parse(this.form.id),
              categoryId: JSON.parse(this.selectedCategory),
              billingAddress: this.form.billingAddress,
              billingCity: this.form.billingCity,
              billingCountry: this.form.billingCountry,
              billingStateCode: JSON.parse(this.selectedBillingState),
              billingStreet: this.form.billingStreet,
              billingZipCode: JSON.parse(this.form.billingZipCode),
              vendorName: this.form.vendorName,
              contactName: this.form.contactName,
              contactNumber: this.form.contactNumber,
              email: this.form.email,
              gstNumber: this.form.gstNumber,
              panNumber: this.form.panNumber,
              shippingAddress: this.form.shippingAddress,
              shippingCity: this.form.shippingCity,
              shippingCountry: this.form.shippingCountry,
              shippingStateCode: JSON.parse(this.selectedShippingState),
              shippingStreet: this.form.shippingStreet,
              shippingZipCode: JSON.parse(this.form.shippingZipCode)
            },
            {
              headers: {
                Authorization: "bearer " + sessionStorage.getItem("token")
              }
            }
          )
          .then(() => {
            this.$toaster.success("Successfully updated");
            //this.$router.push(`counsellingImage/${code}`);
            //this.$router.go(-1);
            this.getData();
            this.btnSave = false;
            window.scrollTo(0, 0);
            this.edit = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      } else {
        this.$toaster.error(`Required field are empty!!`);
      }
    },

    onDelete(item) {
      // alert(item.id);
      if (confirm("You want to delete !!")) {
        this.axios
          .delete(config.API + `VendorDocuments/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully deleted");
            this.getData();
          })
          .catch(err => {
            this.$toaster.error(err.message);
          });
      }
    },

    continues(item) {
      if (confirm("You want to continue !!")) {
        this.btnSave = true;
        this.axios
          .delete(config.API + `Vendors3/${item.id}`, {
            headers: {
              Authorization: "bearer " + sessionStorage.getItem("token")
            }
          })
          .then(() => {
            this.$toaster.success("Successfully updated");
            this.getData();
            this.btnSave = false;
          })
          .catch(err => {
            this.$toaster.error(err.message);
            this.btnSave = false;
          });
      }
    }
  }
};
</script>

<style>
.bckgrnd {
  background-color: #424242;
  background-size:cover !important;
}
.txt_dec {
  text-decoration: none !important;
}
</style>
